const state = {
    publicThankYouMessage: null,
};

const mutations = {
    SET_PUBLIC_THANK_YOU_MESSAGE: (state, info) => {
        state.publicThankYouMessage = info;
    }
};

const actions = {
    setPublicThankYouMessage({ commit }, info) {
        commit("SET_PUBLIC_THANK_YOU_MESSAGE", info);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/public_thank_you_message.js